import { FC } from 'react';

import AngleRight from '@public/images/angle-right.svg';
import AngleLeft from '@public/images/angle-left.svg';
import Linkedin from '@public/images/linkedin.svg';
import Close from '@public/images/x mark.svg';
import Filter from '@public/images/filter-icon.svg';
import Globe from '@public/images/globe.svg';
import Search from '@public/images/search.svg';
import A11y from '@public/images/accessibility.svg';
import AngleUp from '@public/images/angle-up.svg';
import AngleDown from '@public/images/angle-down.svg';
import Eye from '@public/images/eye.svg';
import EyeOff from '@public/images/eye-off.svg';
import List from '@public/images/list.svg';
import Gallery from '@public/images/gallery.svg';
import Ellipsis from '@public/images/ellipsis.svg';
import PhoneIcon from '@public/images/phone.svg';
import MapIcon from '@public/images/map-icon.svg';
import SpinnerImg from '@public/images/Spinner.svg';
import FilterIcon from '@public/images/filter-icon.svg';
import PhoneIconWhite from '@public/images/phone-white.svg';
import MapIconWhite from '@public/images/map-icon-white.svg';
import CloseIconWhite from '@public/images/close-white.svg';
import classNames from 'classnames';

interface IconProps {
    type:
        | 'angleRight'
        | 'angleLeft'
        | 'close'
        | 'linkedin'
        | 'filter'
        | 'globe'
        | 'search'
        | 'a11y'
        | 'angleUp'
        | 'angleDown'
        | 'list'
        | 'gallery'
        | 'ellipsis'
        | 'phone'
        | 'map'
        | 'spinner'
        | 'filterIcon'
        | 'a11tyImg'
        | 'phoneWhite'
        | 'closeWhite'
        | 'mapWhite'
        | 'pwdShow'
        | 'pwdHide';
    className: string;
    width?: number;
    height?: number;
    onClick?: (e?: any) => void;
    active?: boolean;
}

const Icon: FC<IconProps> = ({ type, active, className, width = 20, height = 20, onClick }) => {
    switch (type) {
        case 'angleRight':
            return (
                <AngleRight className={className} width={width} height={height} onClick={onClick} />
            );
        case 'angleLeft':
            return <AngleLeft className={className} width={width} height={height} />;
        case 'linkedin':
            return (
                <Linkedin className={className} width={width} height={height} onClick={onClick} />
            );
        case 'close':
            return <Close className={className} width={width} height={height} onClick={onClick} />;
        case 'filter':
            return <Filter className={className} width={width} height={height} onClick={onClick} />;
        case 'globe':
            return <Globe className={className} width={width} height={height} onClick={onClick} />;
        case 'search':
            return <Search className={className} width={width} height={height} onClick={onClick} />;
        case 'a11y':
            return <A11y className={className} width={width} height={height} onClick={onClick} />;
        case 'angleUp':
            return <AngleUp className={className} width={width} height={height} />;
        case 'angleDown':
            return <AngleDown className={className} width={width} height={height} />;
        case 'pwdShow':
            return <Eye className={className} width={width} height={height} />;
        case 'pwdHide':
            return <EyeOff className={className} width={width} height={height} />;
        case 'list':
            return (
                <List
                    className={classNames('tw-cursor-pointer tw-translate-y-2', {
                        'tw-fill-gray-300': !active,
                        'tw-fill-[#007dba]': active,
                    })}
                    width={width}
                    height={height}
                    onClick={onClick}
                />
            );
        case 'gallery':
            return (
                <Gallery
                    className={classNames('tw-cursor-pointer tw-translate-y-2', {
                        'tw-fill-gray-300': !active,
                        'tw-fill-[#007dba]': active,
                    })}
                    width={width}
                    height={height}
                    onClick={onClick}
                />
            );
        case 'ellipsis':
            return (
                <Ellipsis className={className} width={width} height={height} onClick={onClick} />
            );
        case 'phone':
            return (
                <PhoneIcon className={className} width={width} height={height} onClick={onClick} />
            );
        case 'map':
            return (
                <MapIcon className={className} width={width} height={height} onClick={onClick} />
            );
        case 'spinner':
            return (
                <SpinnerImg
                    className={className}
                    width={width}
                    height={height}
                />
            );
        case 'filterIcon':
            return (
                <FilterIcon className={className} width={width} height={height} onClick={onClick} />
            );
        case 'phoneWhite':
            return (
                <PhoneIconWhite
                    className={className}
                    width={width}
                    height={height}
                    onClick={onClick}
                />
            );
        case 'mapWhite':
            return (
                <MapIconWhite
                    className={className}
                    width={width}
                    height={height}
                    onClick={onClick}
                />
            );
        case 'closeWhite':
            return (
                <CloseIconWhite
                    className={className}
                    width={width}
                    height={height}
                    onClick={onClick}
                />
            );
        default:
            return null;
    }
};

export default Icon;
